import React, { useEffect } from "react";
import ReduxProviders from "@/store/store-provider";
import "@/globals.css";
import { ThemeProvider } from "@/contexts/ThemeContext";
import { ConfirmationProvider } from "@/components/common/ConfirmationDialog";
import { GlobalLoading } from "@/components/common/GlobalLoading";
import { WonderPushLoader } from "@/components/WonderPushLoader";
import { applyWhitelabelTheme, whitelabelConfig } from "@/config/whitelabel";

export function AppLayout({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    document.title = whitelabelConfig.documentTitle;
    applyWhitelabelTheme();

    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement("meta");
      metaDescription.setAttribute("name", "description");
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute("content", whitelabelConfig.metaDescription);

    let favicon = document.querySelector<HTMLLinkElement>('link[rel="icon"]');
    if (!favicon) {
      favicon = document.createElement("link");
      favicon.setAttribute("rel", "icon");
      document.head.appendChild(favicon);
    }
    favicon.setAttribute("href", whitelabelConfig.logos.favicon);
  }, []);

  return (
    <ConfirmationProvider>
      <ReduxProviders>
        <ThemeProvider>
          <WonderPushLoader />
          {/* <p>Test </p> */}
          {children}
          <GlobalLoading />
        </ThemeProvider>
      </ReduxProviders>
    </ConfirmationProvider>
  );
}
